import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useEntity } from '@backstage/plugin-catalog-react';
import {
  useApi,
  configApiRef,
  identityApiRef,
} from '@backstage/core-plugin-api';
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';
import { makeStyles } from '@material-ui/core/styles';
import { useUserRole } from '../../hooks/useUserRole';

const useStyles = makeStyles(theme => ({
  deleteButton: {
    marginLeft: theme.spacing(2),
  },
}));

export const EntityContextMenu = () => {
  const classes = useStyles();
  const { entity } = useEntity();
  const navigate = useNavigate();
  const config = useApi(configApiRef);
  const identityApi = useApi(identityApiRef);
  const { isAdmin } = useUserRole();
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [deleting, setDeleting] = useState(false);

  const handleDeleteEntity = async () => {
    setDeleting(true);
    try {
      const backendUrl = config.getString('backend.baseUrl');
      const { token } = await identityApi.getCredentials();
      const { kind, metadata } = entity;
      const namespace = metadata.namespace || 'default';
      const name = metadata.name;

      const response = await fetch(
        `${backendUrl}/api/catalog/entities/by-name/${kind}/${namespace}/${name}`,
        {
          method: 'DELETE',
          headers: {
            'Content-Type': 'application/json',
            ...(token ? { Authorization: `Bearer ${token}` } : {}),
          },
        },
      );

      if (response.ok) {
        navigate('/catalog');
      } else {
        const errorData = await response.json();
        alert(
          `Error al eliminar la entidad: ${
            errorData.message || errorData.error
          }`,
        );
      }
    } catch (error) {
      console.error('Error deleting entity:', error);
      alert('Error al eliminar la entidad. Por favor, intenta de nuevo.');
    } finally {
      setDeleting(false);
      setDeleteDialogOpen(false);
    }
  };

  if (!isAdmin) {
    return null;
  }

  return (
    <>
      <Button
        variant="outlined"
        color="secondary"
        startIcon={<DeleteIcon />}
        onClick={() => setDeleteDialogOpen(true)}
        className={classes.deleteButton}
      >
        Eliminar Entidad
      </Button>

      <Dialog
        open={deleteDialogOpen}
        onClose={() => setDeleteDialogOpen(false)}
      >
        <DialogTitle>Eliminar Entidad</DialogTitle>
        <DialogContent>
          <DialogContentText>
            ¿Estás seguro de que deseas eliminar la entidad{' '}
            <strong>{entity.metadata.name}</strong>? Esta acción no se puede
            deshacer.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setDeleteDialogOpen(false)}
            disabled={deleting}
          >
            Cancelar
          </Button>
          <Button
            onClick={handleDeleteEntity}
            color="secondary"
            variant="contained"
            disabled={deleting}
          >
            {deleting ? 'Eliminando...' : 'Eliminar'}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
